import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

const ThankYou = () => {
  const location = useLocation();
  const [details, setDetails] = useState({
    bookingRef: 'KE-GBP-CONFIRMED',
    flywireRef: 'Confirmed',
    transactionId: 'TXN-' + Date.now(),
    name: 'Valued Guest',
    email: '',
    amount: '99',
    currency: 'GBP',
    plan: 'Couple Experience'
  });

  useEffect(() => {
    document.title = 'Voucher Activated — Karma Experience';

    let saved = {};
    try {
      saved = JSON.parse(sessionStorage.getItem('karma_activation_data') || '{}');
    } catch(e) {}

    const params = new URLSearchParams(location.search || window.location.search);
    const bookingRef = params.get('booking_ref') || params.get('bookingReference') || saved.bookingRef || ('KE-GBP-' + Math.random().toString(36).substring(2, 8).toUpperCase());
    const rawRef = params.get('payment_id') || params.get('flywireReference') || params.get('reference') || params.get('id');
    const flywireRef = (rawRef && rawRef.toLowerCase() !== 'confirmed' && rawRef.toLowerCase() !== 'pending')
      ? rawRef
      : ('FW-' + bookingRef.replace(/^KE-GBP-/, '').toUpperCase());
    const transactionId = params.get('transaction') || params.get('transactionId') || saved.transactionId || ('TXN-' + Date.now());
    const name = params.get('name') || params.get('firstName') || (saved.firstName ? (saved.firstName + ' ' + (saved.lastName || '')) : 'Valued Guest');
    const email = params.get('email') || saved.email || '';
    const phone = params.get('phone') || params.get('mobile') || saved.phone || '';
    const dialCode = params.get('dialCode') || params.get('dial') || saved.dialCode || '+44';
    const country = params.get('country') || saved.country || 'United Kingdom';
    const amount = params.get('amount') || saved.amount || '99';
    const currency = params.get('currency') || 'GBP';
    const plan = params.get('plan') || saved.planLabel || 'Couple Experience';

    setDetails({
      bookingRef,
      flywireRef,
      transactionId,
      name,
      email,
      phone,
      dialCode,
      country,
      amount,
      currency,
      plan
    });

    // Persist details back into sessionStorage so page refreshes keep the same reference IDs
    saved.bookingRef = bookingRef;
    saved.flywireRef = flywireRef;
    saved.transactionId = transactionId;
    try {
      sessionStorage.setItem('karma_activation_data', JSON.stringify(saved));
    } catch(e) {}

    // Deduplication check: prevent multiple email dispatches on page refresh
    const sentKey = 'email_sent_' + (bookingRef || transactionId);
    let alreadySent = false;
    try {
      if (sessionStorage.getItem(sentKey) === 'true' || localStorage.getItem(sentKey) === 'true') {
        alreadySent = true;
      }
    } catch(e) {}

    if (alreadySent) {
      console.log('Confirmation email already dispatched for reference:', bookingRef);
      return;
    }

    if (email) {
      try {
        sessionStorage.setItem(sentKey, 'true');
        localStorage.setItem(sentKey, 'true');
      } catch(e) {}

      const backendEndpoint = 'http://localhost/karma-uk-suddomain/activation-page/process-payment.php';
      fetch(backendEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firstName: name.split(' ')[0] || 'Valued',
          lastName: name.split(' ').slice(1).join(' ') || 'Guest',
          email: email,
          phone: phone,
          mobile: phone,
          dialCode: dialCode,
          country: country,
          planLabel: plan,
          amount: parseFloat(amount) || 99,
          currency: currency,
          bookingReference: bookingRef,
          flywireReference: flywireRef,
          transactionId: transactionId
        })
      }).then(res => res.json())
        .then(data => console.log('Email dispatch response:', data))
        .catch(err => console.warn('Email dispatch trigger notice:', err));
    }
  }, [location.search]);

  const symbol = details.currency === 'GBP' ? '£' : '$';

  return (
    <div className="min-h-screen bg-[#FBF7EE] flex flex-col font-sans text-[#55606E]">
      <header className="bg-[#0F2340] py-6 px-5 text-center border-b-2 border-[#B8934A]">
        <Link to="/" className="inline-block">
          <img src="/images/logo/KE-white.png" alt="Karma Experience" className="h-9 md:h-10 w-auto mx-auto object-contain" />
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center p-5 sm:p-10">
        <div className="bg-white border border-[#E5DFD3] rounded-2xl max-w-[620px] w-full p-8 sm:p-10 shadow-lg text-center">
          <div className="w-[72px] h-[72px] bg-[#E8F5E9] text-[#1E8A54] rounded-full inline-flex items-center justify-center mb-6">
            <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>

          <h1 className="font-serif text-[#0F2340] text-3xl sm:text-4xl font-semibold mb-3 leading-tight">
            Activation Confirmed
          </h1>
          <p className="text-[15px] leading-relaxed mb-7 text-[#55606E]">
            Thank you, <strong className="text-[#0F2340]">{details.name}</strong>. Your Karma Experience voucher has been successfully activated and your payment processed via Flywire.
          </p>

          <div className="bg-[#FAF8F5] border border-[#E5DFD3] border-l-4 border-l-[#B8934A] rounded-lg p-4 sm:p-5 mb-7 text-left">
            <div className="flex justify-between py-2 border-b border-dashed border-[#EAE3D5] text-sm">
              <span className="text-[#7B8593]">Booking Reference</span>
              <span className="font-semibold text-[#0F2340]">{details.bookingRef}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-dashed border-[#EAE3D5] text-sm">
              <span className="text-[#7B8593]">Flywire Reference</span>
              <span className="font-semibold text-[#B8934A]">{details.flywireRef}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-dashed border-[#EAE3D5] text-sm">
              <span className="text-[#7B8593]">Transaction ID</span>
              <span className="font-semibold text-[#0F2340]">{details.transactionId}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-dashed border-[#EAE3D5] text-sm">
              <span className="text-[#7B8593]">Experience Package</span>
              <span className="font-semibold text-[#0F2340]">{details.plan}</span>
            </div>
            <div className="flex justify-between py-2 border-b border-dashed border-[#EAE3D5] text-sm">
              <span className="text-[#7B8593]">Amount Paid</span>
              <span className="font-semibold text-[#1E8A54]">{symbol}{details.amount} {details.currency}</span>
            </div>
            <div className="flex justify-between py-2 text-sm">
              <span className="text-[#7B8593]">Voucher Validity</span>
              <span className="font-semibold text-[#0F2340]">12 Months from Today</span>
            </div>
          </div>

          <div className="bg-[#F6F8FA] rounded-lg p-5 mb-8 text-left">
            <h3 className="font-serif text-lg text-[#0F2340] font-semibold mb-2">Next Steps for Your Journey</h3>
            <ol className="list-decimal pl-5 text-[13.5px] leading-relaxed space-y-1 text-[#55606E]">
              <li>A confirmation receipt has been sent to <strong>{details.email || 'your email address'}</strong>.</li>
              <li>Our dedicated Experience Team will contact you to assist in selecting your preferred destination and dates.</li>
              <li>You have 12 full months to plan and schedule your getaway.</li>
            </ol>
          </div>

          <Link
            to="/"
            className="inline-block bg-[#0F2340] hover:bg-[#B8934A] text-white hover:text-[#0F2340] text-[13px] uppercase tracking-[1.5px] font-semibold py-3.5 px-8 rounded-full border border-[#B8934A] transition-colors duration-300"
          >
            Return to Karma Experience
          </Link>
        </div>
      </main>

      <footer className="bg-[#0F2340] text-[#94A3B8] text-center text-xs py-6 space-y-2">
        <div>
          &copy; {new Date().getFullYear()} Karma Experience &middot; Karma Group. All rights reserved.
        </div>
        <div className="space-x-3 text-[11.5px] text-[#A0AEC0]">
          <a href="https://karmaexperience.co.uk/privacy-policy.php" target="_blank" rel="noopener noreferrer" className="hover:text-gold underline">Privacy Policy</a>
          <span>&middot;</span>
          <a href="https://karmaexperience.co.uk/terms-and-conditions.php" target="_blank" rel="noopener noreferrer" className="hover:text-gold underline">Terms and Conditions</a>
        </div>
      </footer>
    </div>
  );
};

export default ThankYou;
